export default {
  state: {
    department: [],  // 科室
  },
  getters: {
    department: state => state.department
  },
  mutations: {
    setDepartment(state, department){  // 科室
      state.department = department;
    },
    doneTodos: state => {
      return state.department.filter(todo => todo.done)
    }
  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/department.js